import script from "./Pane4.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane4.vue?vue&type=script&setup=true&lang=js"

import "./Pane4.vue?vue&type=style&index=0&id=57a2978f&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a2978f"]])

export default __exports__